import { Theme } from '../Domain/clientPortalService';

export const DEFAULT_THEME: Theme = {
  coloredBackgroundBlock: {
    backgroundColor: '#426377',
    fontColor: '#FFFFFF',
    shadingColor: '#eefcf0',
    highlightColor: '#4cd964'
  },
  whiteBackgroundBlock: {
    backgroundColor: '#FFFFFF',
    fontColor: '#426377',
    shadingColor: '#DDE7EB4D',
    highlightColor: '#4cd964'
  },
  grayBackgroundBlock: {
    backgroundColor: '#F5F8F9',
    fontColor: '#426377',
    shadingColor: '#ffffff',
    highlightColor: '#4cd964'
  }
};
